<div menuSystem [cerrixTab]="tab">
    <div [attr.name]="'connectionOverview.thirdPartyAssurance' | t" class="" menuicon="fad fa-shield-alt" menuItemId="menuItemThirdPartyAssurance" menusystemitem>
        <app-tpa-overview></app-tpa-overview>
    </div>
</div>
